import { API_URL } from "../utils/urls"; // PT-REACT-URLS v1
import FeatureLayout from './FeatureLayout';
import React, { useState, useEffect } from 'react';
import LightGallery from 'lightgallery/react';
import lgVideo from 'lightgallery/plugins/video';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-video.css';
import { Link } from 'react-router-dom';
import { FaRegNewspaper, FaMicrophoneAlt, FaBullhorn, FaImages } from 'react-icons/fa';
import { HiArrowLongRight } from 'react-icons/hi2';
import { Panel, useSafeAutoplay } from './SectionShared';
import './pt-home.css';

// PT-ORG-LINKS v2: "संगठन" shows the OTHER sites of the group (not the one you are on); each logo opens its website.
const PT_ORGS = [
    { name: "Dr Pravin Togadia", host: "pravinbhaitogadia.com", url: "https://pravinbhaitogadia.com/", logo: process.env.PUBLIC_URL + "/images/orgs/pravinbhaitogadia.jpg" },
    { name: "Ojaswini", host: "ojaswini.info", url: "https://ojaswini.info/", logo: process.env.PUBLIC_URL + "/images/orgs/ojaswini.jpg" },
    { name: "Antarrashtriya Hindu Parishad", host: "antarrashtriyahinduparishad.com", url: "https://antarrashtriyahinduparishad.com/", logo: process.env.PUBLIC_URL + "/images/orgs/antarrashtriyahinduparishad.png" },
    { name: "Rashtriya Mahila Parishad", host: "rashtriyamahilaparishad.com", url: "https://www.rashtriyamahilaparishad.com/", logo: process.env.PUBLIC_URL + "/images/orgs/rashtriyamahilaparishad.png" },
    { name: "Rashtriya Bajrang Dal", host: "rashtriyabajrangdal.com", url: "https://www.rashtriyabajrangdal.com/", logo: process.env.PUBLIC_URL + "/images/orgs/rashtriyabajrangdal.png" },
    { name: "Rashtriya Chhatra Parishad", host: "rashtriyachhatraparishad.com", url: "https://rashtriyachhatraparishad.com/", logo: process.env.PUBLIC_URL + "/images/orgs/rashtriyachhatraparishad.png" },
];
const ptOrgSlides = () => {
    const here = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase().replace(/^www\./, "");
    const others = PT_ORGS.filter((o) => o.host !== here);
    const slides = [];
    while (slides.length < 12) slides.push(...others); // the slider loops, so it needs more slides than it shows
    return slides.map((o, i) => ({ id: i + 1, category_name: o.name, url: o.url, logo: o.logo }));
};


const GALLERY_HOME_COUNT = 12; // homepage gallery mein 12 photos

const SHORTCUTS = [
  { to: '/view-all/24', title: 'Newspaper Coverage', text: 'Media coverage and newspaper articles', Icon: FaRegNewspaper },
  { to: '/video-news-view/27', title: 'Speech Videos', text: 'Watch speeches and recorded events', Icon: FaMicrophoneAlt },
  { to: '/view-all/29', title: 'Latest News', text: 'Read the latest news and updates', Icon: FaBullhorn },
  { to: '/gallery-image', title: 'Photo Gallery', text: 'Programmes, yatras and memories', Icon: FaImages },
];

const HomePage = () => {
  const [imageData, setImageData] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          API_URL + 'get_gallery',
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        const allImages = response?.data?.data || [];
        const galleryImages = allImages.filter(
          (image) => image.type === 'gallery'
        );
        console.log("HOME GALLERY → total:", allImages.length, "| gallery type:", galleryImages.length, "| types:", [...new Set(allImages.map((i) => i.type))]);
        setImageData(galleryImages.slice(0, GALLERY_HOME_COUNT));
      } catch (error) {
        console.error('Error fetching gallery data:', error);
      } finally {
        setGalleryLoading(false);
      }
    };

    fetchData();
  }, []);

  // Swiper breakpoints are min-width (mobile-first). Earlier the base was 6,
  // so phones showed 6 tiny logos while desktop showed only 4.
  const onOrgSwiper = useSafeAutoplay(2500, true);

  const settings = {
    slidesPerView: 2,
    slidesPerGroup: 1,
    loop: true,
    spaceBetween: 16,
    breakpoints: {
      520: { slidesPerView: 3 },
      768: { slidesPerView: 4 },
      1200: { slidesPerView: 5, spaceBetween: 24 },
    },
  };

  const imagehandler = (url) => {
    if (url && url !== '') {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      alert('No URL available for this brand.');
    }
  };

  const Data = ptOrgSlides();

  const shortcuts = (
    <section className="pt-shortcuts">
      <div className="container">
        <div className="pt-shortcuts-grid">
          {SHORTCUTS.map(({ to, title, text, Icon }) => (
            <Link key={to} to={to} className="pt-shortcut">
              <span className="pt-shortcut-icon" aria-hidden="true">
                <Icon />
              </span>
              <span className="pt-shortcut-copy">
                <span className="pt-shortcut-title">{title}</span>
                <span className="pt-shortcut-text">{text}</span>
              </span>
              <span className="pt-shortcut-arrow" aria-hidden="true">
                <HiArrowLongRight />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );

  const galleryPanel = {
    key: 'photo-gallery',
    kind: 'news',
    node: (
      <Panel title="Photo Gallery" viewAllTo="/gallery-image" className="pt-panel--gallery">
        {galleryLoading ? (
          <div className="pt-gallery-grid">
            {Array.from({ length: GALLERY_HOME_COUNT }).map((_, i) => (
              <div key={i} className="pt-gallery-item pt-skeleton" />
            ))}
          </div>
        ) : imageData.length > 0 ? (
          <LightGallery
            plugins={[lgVideo]}
            mode="lg-fade"
            elementClassNames="pt-gallery-grid"
            download={false}
          >
            {imageData.map((image, index) => (
              <a
                key={image.id || index}
                href={image.image}
                data-src={image.image}
                data-sub-html={image.title ? `<h4>${image.title}</h4>` : undefined}
                className="pt-gallery-item"
              >
                <img src={image.image} alt={image.title || 'Gallery'} loading="lazy" />
              </a>
            ))}
          </LightGallery>
        ) : (
          <p className="text-center my-4">No photos available.</p>
        )}
      </Panel>
    ),
  };

  return (
    <>
      <FeatureLayout afterFeatured={shortcuts} extraPanels={[galleryPanel]} />

      {/* Organization Carousel */}
      <section className="pt-section pt-org">
        <div className="container">
          <div className="pt-panel">
            <div className="pt-panel-head pt-panel-head--center">
              <h2>संगठन</h2>
            </div>
            <div className="pt-panel-body">
              <Swiper {...settings} onSwiper={onOrgSwiper} className="pt-org-swiper">
                {Data.map((element, index) => (
                  <SwiperSlide key={`${element.category_name}-${index}`}>
                    <button
                      type="button"
                      className="pt-org-item"
                      onClick={() => imagehandler(element.url)}
                      aria-label={`Open ${element.category_name}`}
                    >
                      <img src={element.logo} alt={element.category_name} loading="lazy" />
                    </button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
